import { useQuery } from "@tanstack/react-query";
import { getWidgetActionsApiClient } from "@shared/apis/sidekick/api-factories";
import { TerritorySuggestionsResponse } from "@shared/apis/sidekick/generated";
import { extractQueryState } from "../helpers/extract-query-state";

const WIDGETS_GET_TERRITORY_SUGGESTIONS_QUERY_KEY =
  "widgets-get-territory-suggestions";
const CACHE_TIME_IN_MS = 1000 * 60 * 60; // 60 minutes

export const buildWidgetsGetTerritorySuggestionsQueryKey = ({
  query,
}: {
  query: string;
}) => {
  return [WIDGETS_GET_TERRITORY_SUGGESTIONS_QUERY_KEY, { query }];
};

export function useWidgetsGetTerritorySuggestions(props: {
  query: string;
  onSuccess?: (data: TerritorySuggestionsResponse) => void;
}) {
  const { query: queryParam, onSuccess } = props;
  const api = getWidgetActionsApiClient();

  const query = useQuery({
    queryKey: buildWidgetsGetTerritorySuggestionsQueryKey({
      query: queryParam,
    }),
    queryFn: async () => {
      const response = await api.widgetsControllersSidekickTerritorySuggestions(
        {
          territorySuggestionsRequest: {
            query: queryParam,
            maxPerTerritoryType: 5,
          },
        },
      );
      onSuccess?.(response);
      return response;
    },
    enabled: queryParam.trim().length > 0,
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      const status = (error as any)?.response?.status || 0;
      if (failureCount < 3 && status === 429) {
        return true;
      }
      return false;
    },
    gcTime: CACHE_TIME_IN_MS,
    staleTime: CACHE_TIME_IN_MS,
  });

  return extractQueryState(query);
}
